module.exports = __webpack_public_path__ + "static/media/one-token.a3314b8b.svg";